// OXX-883: i18next initialisation.
//
// Locale is read from <meta name="locale"> injected by the Rails layout.
// Falls back to 'en' for any missing key — no broken UI, just untranslated strings.
// Timezone is read from <meta name="timezone"> and exposed for Intl.DateTimeFormat use.

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getMeta } from '@/lib/utils'

import en from './locales/en.json'
import ja from './locales/ja.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import pt from './locales/pt.json'
import zh from './locales/zh.json'
import ko from './locales/ko.json'
import ar from './locales/ar.json'

export const LOCALE_STORAGE_KEY = 'ov3_user_locale'
export const appLocale   = getMeta('locale')   || 'en'
export const appTimezone = getMeta('timezone') || 'UTC'

// Honor a stored preference only when it's a valid choice for this tenant:
// either 'en' (always available) or the tenant's own configured locale.
// Any other stored value is silently ignored to prevent stale cross-tenant overrides.
const _stored =
  typeof localStorage !== 'undefined' ? localStorage.getItem(LOCALE_STORAGE_KEY) : null
const effectiveLocale =
  _stored === 'en' || _stored === appLocale ? _stored : appLocale

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ja: { translation: ja },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      pt: { translation: pt },
      zh: { translation: zh },
      ko: { translation: ko },
      ar: { translation: ar },
    },
    lng:        effectiveLocale,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already XSS-escapes
    },
  })

export default i18n
